// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-ec237c4c] .link span{display:flex;align-items:baseline;gap:6px}", "",{"version":3,"sources":["/home/circleci/mikmak-dashboard/src/components/dashboard/Common/TitleWithLink.vue"],"names":[],"mappings":"AAqCE,6BACE,YAAA,CACA,oBAAA,CACA,OAAA","file":"TitleWithLink.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n::v-deep .link {\n  span {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
